import { Button, Select} from 'flowbite-react'
import React, { useState } from 'react'

import { FileInput, Label } from "flowbite-react";


function UploadImage() {
    const ImageCategory = [
        "Rajasthani",
        "AntiqueGold",
        "Marwadi",
        "Silver"
    ]
    const [selectedImageCatagory, setselectedImageCatagory] = useState(ImageCategory[0])
    const handleChangeSelectedValue =(event) => {
        console.log(event.target.value);
        setselectedImageCatagory(event.target.value);
    }

    const handleImageSubmit = (event) => {
      event.preventDefault();
      const form = event.target;
      const category = form.category.value;
      const imageFile = form.imageUrl.files[0]; 
      const token = localStorage.getItem("token");

      if (!token) {
        alert("Authentication token not found. Please log in.");
        return; 
      }
    
      if (!imageFile) {
        alert("Please upload an image.");
        return;
      }
    
      // Create FormData to handle file uploads
      const formData = new FormData();
      formData.append("category", category);
      formData.append("imageUrl", imageFile);
    
      
      fetch("https://jewellery-mysql-backend.onrender.com/admin/addimages", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`, 
        },
        body: formData, 
      })
        .then((res) => res.json())
        .then((data) => {
          if(data.success){
          alert("Image uploaded successfully!");
          form.reset();
          }else {
            const errorMessage = data.errors?.[0]?.msg || "Failed to upload image.";
            alert(errorMessage);
          }
        })
        .catch((error) => {
          console.error("Error uploading image:", error);
          alert("Failed to upload image.");
        });
    };

  return (
    <div className=' px-4 my-12 m-auto lg:w-[1140px] '>
      <h2 className='font-bold text-3xl mb-6 text-center'>Upload Image</h2>
      <form onSubmit={handleImageSubmit} className='flex flex-col gap-6' >
        <div>
        <div>
            <label htmlFor="inputState" value="Category">Image Category</label>
        </div>
        <Select name="category" id="inputState" className='w-full rounded' value={selectedImageCatagory} onChange={handleChangeSelectedValue}>
       { ImageCategory.map((option) => <option key={option} value={option}> {option} </option> )}
        </Select>
        </div>
        <div>
      <div>
        <Label htmlFor="file-upload-helper-text" value="Upload file" />
      </div>
      <FileInput name="imageUrl" id="file-upload-helper-text" helperText="SVG, PNG, JPG or GIF (MAX. 2MB)." required />
    </div>
    <Button type='submit' >
        Upload Image
    </Button>
      </form>
    </div>
  )
}

export default UploadImage
